
interface Props {
  src: string;
  onClick: () => void;
}

export const LogoHeader = ({src, onClick}: Props) => (<img
  style={{ cursor: 'pointer' }}
  onClick={onClick}
  src={src}
  width="100px"
  height="32px"
  alt="Logo"
/>)
